module.exports = __WEBPACK_EXTERNAL_MODULE_121__;


//////////////////
// WEBPACK FOOTER
// external "u2f-api-polyfill"
// module id = 121
// module chunks = 0